import React, {useState}  from "react";
import './introduction.css';

const Introduction = () => {


    const [bar, setBar] = useState();

    return (
        <div className="introduction">
            <div className="introduction-texts">
                <div className="introduction-text introduction-text-small">Hello. I am </div>
                <div className="introduction-text introduction-text-big">Tim Schneider </div>
                <div className="introduction-text introduction-text-small">PhD Student </div>
                <div className="introduction-text introduction-text-small">@ University of Stuttgart</div>
            </div>

            <div className="introduction-image">
                <svg width="100%" height="100%"> 
                    <circle r="50%" cx="50%" cy="70%" fill="darkolivegreen"></circle>
                </svg>
                <img src="./Tim (freigestellt).png"/>
            </div>
        </div>
    )
};


export default Introduction